export default {
  fields: {
    list: [
      {
        fieldName: "ticker",
        displayName: "Identifier",
      },
    ],
    form: [
      {
        fieldName: "ticker",
        displayName: "Identifier",
      },
    ],
  },
};
